<script setup>
const { locale, locales, setLocale } = useI18n();

const languagePanel = ref(null);

const language = computed({
  get: () => locale.value,
  set: value => setLocale(value),
});

const switchLanguage = async newLocale => {

  await setLocale(newLocale);
};

const toggle = event => {
  languagePanel.value.toggle(event);
};
const props = defineProps({
  isScrolled: {
    type: Boolean,
    default: false,
    required: false,
  },
});
const route = useRoute()
</script>

<template>
  <ClientOnly>
    <PrimeButton
      :label="$t('navigation.languages.' + language)"
      icon="pi pi-language"
      @click="toggle"
      text
      severity="contrast"
      class="px-2 py-1 text-white focus:shadow-none"
      :size="isScrolled ? 'small' : 'medium'"
    />
    <PrimePopover id="language_panel" ref="languagePanel" append-to="body">
      <div class="flex flex-col gap-3">
        <div v-for="currentLocale in locales" :key="currentLocale.code" class="flex items-center">
          <PrimeRadioButton
            v-model="language"
            :inputId="currentLocale.code"
            name="language"
            class="gap-3"
            :value="currentLocale.code"
            @click="switchLanguage(currentLocale.code)"
          />
          <label :for="currentLocale.code" @click="switchLanguage(currentLocale.code)" class="ml-2 cursor-pointer">
            {{ $t('navigation.languages.' + currentLocale.name) }}
          </label>
        </div>
      </div>
    </PrimePopover>
  </ClientOnly>
</template>
